import { FC } from 'react';
import Link from 'next/link';
import classNames from 'classnames';

import { i18n as I18n } from 'utils/i18n';

import AddToBookingButton from '../addToBookingButton';
import SpacePrice from '../spacePrice';

interface Space {
  id: number;
  name: string;
  priceIncVat: number;
  clinical: boolean;
}

interface Venue {
  id: number;
}

interface Props {
  space: Space;
  disabled?: boolean;
  addedToBooking?: boolean;
  onAddToBooking?: (space: Space, venue: Venue) => void;
}

const SpaceDetails: FC<Props> = ({
  venue,
  space,
  space: { name, priceIncVat, clinical } = {},
  disabled = false,
  addedToBooking = false,
  onAddToBooking: addToBooking,
}) => {
  const className = classNames(
    'calendar__space_details',
    clinical
      ? 'calendar__space_details--clinical'
      : 'calendar__space_details--non-clinical'
  );

  return (
    <div className={className}>
      <h4>
        <Link href={`${I18n.t('navigation.spaces.url')}/${space.id}`}>
          <a>{name}</a>
        </Link>
      </h4>
      <SpacePrice
        price={priceIncVat}
        labelPosition="side"
        labelText={I18n.t('space_list_item.price.per_hour')}
      />
      {addToBooking && (
        <span>
          <AddToBookingButton
            className="space-list-item__book-btn"
            onClick={() => addToBooking(space, venue)}
            added={addedToBooking}
            enabled={!disabled}
            desktop
          />
        </span>
      )}
    </div>
  );
};

export default SpaceDetails;
